// 查询每个区域包含的空调
import request from "@/util/request.js";
export const AirDevice = (token, areaIds, branchName = null) => {
  return request.post("api/sansint-energy/air/AirDevice/list", {
    token,
    areaIds,
    branchName
  });
};
// 空调设备详情
export const AirDeviceDetail = id => {
  return request.get("/api/sansint-energy/air/AirDevice/" + id);
};
// 空跳开关
export const deviceControl = (
  conVal,
  collectorSerial,
  deviceType,
  branchCode,
  branchId,
  subStr
) => {
  return request.post("/api/sansint-energy/deviceControl/onoff", {
    conVal,
    collectorSerial,
    deviceType,
    branchCode,
    branchId,
    subStr
  });
};
// 保存设置
export const saveAirOption = (
  modeControl,
  tempControl,
  speedControl,
  winddireControl,
  collectorSerial,
  deviceType,
  branchCode,
  branchId,
  subStr
) => {
  return request.post("/api/sansint-energy/deviceControl/saveAirOption", {
    modeControl,
    tempControl,
    speedControl,
    winddireControl,
    collectorSerial,
    deviceType,
    branchCode,
    branchId,
    subStr
  });
};
// 模式
export const modeAirOption = (
  conVal,
  collectorSerial,
  deviceType,
  branchCode,
  branchId,
  subStr
) => {
  return request.post("/api/sansint-energy/deviceControl/mode", {
    conVal,
    collectorSerial,
    deviceType,
    branchCode,
    branchId,
    subStr
  });
};
// 温度
export const tempAirOption = (
  conVal,
  collectorSerial,
  deviceType,
  branchCode,
  branchId,
  subStr
) => {
  return request.post("/api/sansint-energy/deviceControl/temp", {
    conVal,
    collectorSerial,
    deviceType,
    branchCode,
    branchId,
    subStr
  });
};
//风速
export const speedAirOption = (
  conVal,
  collectorSerial,
  deviceType,
  branchCode,
  branchId,
  subStr
) => {
  return request.post("/api/sansint-energy/deviceControl/speed", {
    conVal,
    collectorSerial,
    deviceType,
    branchCode,
    branchId,
    subStr
  });
};
